// extracted by mini-css-extract-plugin
export default {"menu":"desktop_type-module__menu--cQYE5"};